"use strict";import{tag as l}from"../custom-tag.js";export function priceIcon({height:e=16,width:r=16,hidden:t=!1,title:a="Price"}={}){return l`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${r}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${a}"
    >
      <mask
        id="price_svg__mask0_6875_6656"
        width="14"
        height="20"
        x="5"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M18.933 14.822q0 1.825-1.208 3.029-1.251 1.244-3.668 1.556V22h-3.646v-2.656q-2.46-.456-3.713-2.074-.834-1.1-1.098-2.656h4.415q.352 1.95 2.394 1.95 1.934 0 1.933-1.245 0-.788-.746-1.182-.593-.311-2.285-.706-2.9-.684-4.085-1.887-1.077-1.08-1.077-2.822Q6.15 7 7.313 5.88q1.099-1.058 3.098-1.37V2h3.646v2.51q3.866.582 4.547 4.274H14.32q-.154-.81-.637-1.182-.484-.374-1.384-.374-.747 0-1.165.29-.395.29-.395.83 0 .727.55 1.038.482.29 1.888.58 3.273.706 4.591 1.93 1.164 1.1 1.164 2.926"
        />
      </mask>
      <g mask="url(#price_svg__mask0_6875_6656)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=price.js.map
